<div class='video-content'>
    <video id="video" class="video-js vjs-sublime-skin vjs-16-9" controls autoplay preload="auto">
    </video>
</div>